import clsx from 'clsx'
import { ICONS } from '@Const/common'
import React, { useState } from 'react'
import Pluralize from 'pluralize'
import './index.scss'

interface DragAndDropZoneProps {
    onFilesChosen: (files: FileList | null, allowMultipleUploads: boolean) => void
    uploadFileTypesString: string
    maxFileSizeString: string
    allowMultipleUploads: boolean
}

const DragAndDropZone = (props: DragAndDropZoneProps) => {
    const { onFilesChosen, uploadFileTypesString, maxFileSizeString, allowMultipleUploads } = props
    const [dragOver, setDragOver] = useState<boolean>(false)
    return (
        <div
            className={clsx('drag-and-drop-zone', dragOver && 'drag-over')}
            onDragOver={(event) => {
                event.preventDefault()
                if (!dragOver) {
                    setDragOver(true)
                }
            }}
            onDragLeave={(event) => {
                event.preventDefault()
                setDragOver(false)
            }}
            onDrag={(event) => {
                event.preventDefault()
            }}
            onDrop={(event) => {
                onFilesChosen(event.dataTransfer.files, allowMultipleUploads)
                event.preventDefault()
            }}
        >
            <div className="upload-center">
                <img src={ICONS.upload} alt="upload" />
                <h3>Drag & Drop {Pluralize('File', allowMultipleUploads ? 2 : 1)} Here</h3>
            </div>
            <span className="description">{`${uploadFileTypesString} only. Files should not exceed ${maxFileSizeString} in size.`}</span>
        </div>
    )
}
export default DragAndDropZone
